import React, { useEffect, useState } from "react";
import pkg_bg from "../../assets/images/pkg_bg.png";
import yard_sign from "../../assets/images/yard_sign.png";
import advertising_creditsIcon from "../../assets/images/advertising_credits.png";
import lockboxes from "../../assets/images/lockboxes.png";
import { FaPlusSquare, FaMinusSquare } from "react-icons/fa";
import { GoCheck } from "react-icons/go";
import PackageCards from "./PackageCards";

export default function PackagesList({ package_type, setTotal_price, setActiveStep, setPackage_type, setSelected_items, handleBack }) {
    const [showScreen, setShowScreen] = useState(0);
    const [yardCount, setYardCount] = useState(0);
    const [lockBoxesCount, setLockBoxesCount] = useState(0);
    const [advertising_credits, setAdvertising_credits] = useState(0);
    const [selectedPackage, setSelectedPackage] = useState({
        title: "",
        price: "",
        aminities: [],
    });

    useEffect(() => {
        const localYardCount = localStorage.getItem("yardCount");
        const localLockBoxesCount = localStorage.getItem("lockBoxesCount");
        const localAdvertising_credits = localStorage.getItem("advertising_credits");
        if (localYardCount) {
            setYardCount(localYardCount);
        }
        if (localLockBoxesCount) {
            setLockBoxesCount(localLockBoxesCount);
        }
        if (localAdvertising_credits) {
            setAdvertising_credits(localAdvertising_credits);
        }
    }, []);

    const onClickMinus = (index) => {
        if (index === 0) {
            if (yardCount > 0) {
                setYardCount(Number(yardCount) - 1);
                localStorage.setItem("yardCount", Number(yardCount) - 1);
            }
        } else if (index === 1) {
            if (lockBoxesCount > 0) {
                setLockBoxesCount(Number(lockBoxesCount) - 1);
                localStorage.setItem("lockBoxesCount", Number(lockBoxesCount) - 1);
            }
        } else {
            if (advertising_credits > 0) {
                setAdvertising_credits(Number(advertising_credits) - 1);
                localStorage.setItem("advertising_credits", Number(advertising_credits) - 1);
            }
        }
    };

    const onClickPlus = (index) => {
        if (index === 0) {
            const newCount = Number(yardCount) + 1;
            setYardCount(newCount);
            localStorage.setItem("yardCount", newCount);
        } else if (index === 1) {
            const newCount = Number(lockBoxesCount) + 1;
            setLockBoxesCount(newCount);
            localStorage.setItem("lockBoxesCount", newCount);
        } else {
            const newCount = Number(advertising_credits) + 1;
            setAdvertising_credits(newCount);
            localStorage.setItem("advertising_credits", newCount);
        }
    };

    const pricingSummaryArray = [
        {
            title: "Listing Package",
            value: selectedPackage.price + "/Month",
        },
        {
            title: "Yard Sign (" + yardCount + ")",
            value: "$" + (yardCount * 70).toFixed(2),
        },
        {
            title: "Lockboxes (" + lockBoxesCount + ")",
            value: "$" + (lockBoxesCount * 70).toFixed(2),
        },
        {
            title: "Advertising Credits (" + advertising_credits + ")",
            value: "$" + advertising_credits * 70,
        },
        // {
        //   title: 'Tax fee',
        //   value: '2%',
        // },
    ];
    const credetsArray = [
        {
            icon: yard_sign,
            title: "Yard Sign",
            price: "$70",
            count: yardCount,
        },
        {
            icon: lockboxes,
            title: "Lockboxes",
            price: "$70",
            count: lockBoxesCount,
        },
        {
            icon: advertising_creditsIcon,
            title: "Advertising Credits",
            price: "$70",
            count: advertising_credits,
        },
    ];
    const calculateTotal = (pricingArray) => {
        let total = 0;

        pricingArray.forEach((item) => {
            if (item.title !== "Tax fee") {
                const numericValue = parseFloat(item.value.replace(/[^0-9.-]+/g, ""));
                total += numericValue;
            }
        });

        return total;
    };
    const total = calculateTotal(pricingSummaryArray);
    const onClickProceedToPayment = () => {
        if (yardCount) {
            setSelected_items((prev) => [...prev, { name: "yard_sign", count: yardCount }]);
        }
        if (lockBoxesCount) {
            setSelected_items((prev) => [...prev, { name: "lockbox", count: lockBoxesCount }]);
        }
        if (advertising_credits) {
            setSelected_items((prev) => [...prev, { name: "advertising_credits", count: advertising_credits }]);
        }
        setTotal_price(total);
        setActiveStep((prev) => prev + 1);
    };
    const onPrev = () => {
        if (showScreen > 0) {
            setShowScreen(showScreen - 1);
        } else {
            handleBack();
        }
    };
    const styles = {
        noSelect: {
            userSelect: "none",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
        },
    };
    return (
        <>
            <div className="tw-w-[100%] tw-flex tw-justify-center pb-4">
                {showScreen === 0 ? (
                    <PackageCards
                        setPackage_type={setPackage_type}
                        setActiveStep={setActiveStep}
                        setSelectedPackage={setSelectedPackage}
                        setShowScreen={setShowScreen}
                    />
                ) : (
                    <div className="tw-w-[90%]">
                        <h2 className="tw-text-[#333333] tw-text-[32px] tw-mt-[25px] tw-font-[700] tw-text-center">
                            Review Your Options Before Checkout.
                        </h2>
                        <div className="tw-flex tw-flex-col xl:tw-flex-row tw-gap-5 tw-w-full tw-mt-5 tw-items-start">
                            <div className="tw-bg-white tw-p-5 tw-w-full xl:tw-w-[50%] tw-rounded-md">
                                <div className="tw-bg-white tw-p-5 tw-border-1 tw-border-primary tw-rounded-[8px] tw-w-full ">
                                    <div className="tw-flex tw-items-center tw-justify-between">
                                        <h3 className="tw-text-[#333333] tw-text-[22px] tw-font-[600]">{selectedPackage.title}</h3>
                                    </div>
                                    <div className="tw-flex tw-justify-between tw-mt-5">
                                        <p className="tw-text-primary tw-[20px] tw-font-[800]">{selectedPackage.price}/Month</p>
                                        {package_type !== "deluxe" && (
                                            <button
                                                onClick={() => setShowScreen(0)}
                                                className="tw-underline tw-text-[#2C3E50] tw-text-[16px] tw-font-[600] "
                                            >
                                                Upgrade plan
                                            </button>
                                        )}
                                    </div>
                                    <div className="tw-flex tw-flex-col tw-gap-2 tw-mt-5">
                                        {Object.entries(selectedPackage?.aminities).map(([key, value]) => (
                                            <div key={key} className="tw-flex tw-gap-1  tw-text-[13px]">
                                                <span className="tw-text-primary ">✓</span>
                                                <span>
                                                    <span className="tw-font-[500]">{key}</span>: {value}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="tw-flex tw-flex-col tw-gap-5 tw-mt-5">
                                    {credetsArray.map((item, index) => (
                                        <div
                                            key={index}
                                            className="tw-flex tw-relative tw-items-center tw-gap-5 tw-h-[107px] tw-px-5 tw-w-full tw-no-select tw-bg-white tw-border-1 tw-border-primary tw-rounded-[8px]"
                                        >
                                            <img src={item.icon} alt="yard sign" className="tw-h-[67px] tw-w-[67px] tw-no-select" />
                                            <div>
                                                <div className="tw-h-[67px] tw-flex tw-flex-col tw-justify-around">
                                                    <h3 className="tw-text-[#333333] tw-text-[18px] tw-font-[600] tw-no-select">{item.title}</h3>
                                                    <p className="tw-text-primary tw-[20px] tw-font-[800] tw-no-select">{item.price}</p>
                                                </div>
                                                <div className="md:tw-absolute tw-right-5 tw-bottom-5 tw-flex tw-items-center tw-gap-2">
                                                    <FaMinusSquare
                                                        className={"tw-text-primary tw-cursor-pointer"}
                                                        onMouseDown={(e) => e.preventDefault()}
                                                        onClick={() => onClickMinus(index)}
                                                        size={25}
                                                        style={styles.noSelect}
                                                    />
                                                    <p className="tw-no-select">{item.count}</p>
                                                    <FaPlusSquare
                                                        className={"tw-text-primary tw-cursor-pointer"}
                                                        onMouseDown={(e) => e.preventDefault()}
                                                        onClick={() => onClickPlus(index)}
                                                        size={25}
                                                        style={styles.noSelect}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="tw-bg-white tw-flex tw-flex-col tw-w-full tw-p-5 xl:tw-w-[50%] tw-rounded-md tw-pb-10">
                                <h2 className="tw-text-[#333333] tw-text-center tw-text-[22px] tw-font-[700] tw-mt-5 tw-no-select">
                                    Pricing Summary
                                </h2>
                                {pricingSummaryArray.map((item, index) => (
                                    <div
                                        key={index}
                                        className="tw-flex tw-w-full tw-justify-between tw-items-center tw-text-[#666666] tw-text-[18px] tw-mt-4"
                                    >
                                        <p>{item.title}</p>
                                        <p>{item.value}</p>
                                    </div>
                                ))}
                                <div className="tw-bg-border_color tw-h-[2px] tw-w-full tw-my-2"></div>
                                <div className="tw-flex tw-w-full tw-justify-between tw-items-center tw-text-[#666666] tw-text-[20px] tw-mt-4">
                                    <p>Total</p>
                                    <p>${total.toFixed(2)}</p>
                                </div>

                                <div className="tw-w-full tw-flex tw-justify-center">
                                    <button
                                        onClick={onClickProceedToPayment}
                                        className={`tw-bg-primary tw-mt-5 tw-w-full tw-h-[55px] tw-rounded-md tw-text-center tw-text-white`}
                                    >
                                        Proceed to Payment
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className="tw-flex tw-justify-center">
                <div className={`navigation-buttons tw-mb-2 tw-mt-auto tw-justify-between ${showScreen === 0 ? "tw-w-[100%]" : "tw-w-[90%]"}`}>
                    <button
                        name="submit"
                        className="prev-button tw-rounded-[8px] tw-bg-white tw-border tw-border-primary tw-text-gray-500 tw-px-4 tw-py-2 tw-shadow-sm tw-transition-colors tw-duration-200 tw-ease-in-out hover:tw-bg-gray-100 disabled:tw-cursor-not-allowed"
                        onClick={onPrev}
                    >
                        Prev
                    </button>
                </div>
            </div>
        </>
    );
}
